import React from "react";
import { logo_blue } from "../../../assets";
import { Button, Form, Input } from "../../../styles";
import SettingsWrapper from "../../../layout/SettingsWrapper";
import { useUserContext } from "../../../context/user_context";

function PersonalProfile() {

  const { userData } = useUserContext();

  const {
    fullname, mail, phone, photo, accountData, username
  } = userData;



  // Route to Reni Trust

  function editConfirm(e) {
    e.preventDefault();
    if (window.confirm('You will redirected to your Renitrust Account, Confirm?')) {
      window.open('https://renitrust.com/user/profile', '_blank');
    }
  }

  // Route to Reni Trust

  return (
    <>
      <SettingsWrapper
        title="PERSONAL PROFILE">
        <Form>
          <div className=" py-4 img-container my-4 mx-auto " >
            <img src={photo || logo_blue} alt={'Avaatar'} width="100%" />
          </div>

          <div className="row justify-content-center">
            <div className="col-md-6 ">
              <label> Name: </label>
              <Input
                type="text"
                name="cname"
                placeholder="Enter Name"
                value={fullname}
                disabled
              />
            </div>
            <div className="col-md-6 ">
              <label> Username: </label>
              <Input
                type="text"
                name="cname"
                placeholder="Enter Name"
                value={username}
                disabled
              />
            </div>

            <div className="col-md-6 ">
              <label> Phone Number: </label>
              <Input
                type="number"
                name="phone"
                placeholder="e.g. 08012345678"
                value={phone}
                disabled
              />
            </div>

            <div className="col-md-6 ">
              <label> Email: </label>
              <Input
                type="email"
                name="email"
                placeholder="Enter Email"
                value={mail}
                disabled
              />
            </div>
            <div className="col-md-6 ">
              <label> Bank Name: </label>
              <Input
                type="text"
                name="bankname"
                placeholder="Bank Name"
                value={accountData?.data?.bankname}
                disabled
              />
            </div>
            <div className="col-md-6 ">
              <label> Bank Account Number: </label>
              <Input
                type="number"
                name="accountnumber"
                placeholder="Bank Account Number"
                value={accountData?.data?.nuban}
                disabled
              />
            </div>
            <div className="col-md-6 ">
              <label> Bank Account Name: </label>
              <Input
                type="text"
                name="accountname"
                placeholder="Back Account Name"
                value={accountData?.data?.name}
                disabled
              />
            </div>
            <div className="col-md-12  mx-auto text-center">
              <div className="mb-4">

                <Button
                  type="button"
                  pry
                  className="btn w-100"
                  onClick={(e) => editConfirm(e)}
                >
                  Manage your Reni Account
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </SettingsWrapper>


    </>
  );
}

export default PersonalProfile;
